import React, { useState, useEffect, memo } from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Button, LinearProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import toast from 'react-hot-toast';

const AddComplaintMessage = (({ handleClose, updateComplaintStatus, MessageLoading, complaintModal }) => {
    const [localMessage, setLocalMessage] = useState('');

    useEffect(() => {
        setLocalMessage(''); 
    }, [complaintModal]);

    const handleLocalMessageChange = (e) => {
        setLocalMessage(e.target.value); 
    };

    const handleSave = () => {
        updateComplaintStatus(localMessage);
    };

    return (
        <>
            <div>
                <Modal open={complaintModal}>
                    <Box
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '10px',
                            width: '558px',
                            height: 'auto',
                        }}
                        className='modal-resp-settings'
                    >
                        <Box style={{ display: 'flex' }}>
                            <Typography
                                style={{
                                    fontSize: '18px',
                                    color: '#252F46',
                                    fontWeight: '700',
                                }}
                            >
                                Add Complaint Message
                            </Typography>
                        </Box>
                        <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                        <Box style={{padding: '10px'}}>
                            <Box style={{ display: 'grid', gap: '10px', marginTop: '10px' }}>
                                <TextField
                                    fullWidth
                                    id="message"
                                    name="message"
                                    placeholder="write message ..."
                                    multiline
                                    rows={3}
                                    value={localMessage} // Use local state here
                                    sx={{
                                        width: '100%',
                                        minHeight: '200px', // Ensure minimum height
                                        overflowY: 'auto',
                                        '& .MuiInputBase-input': {
                                            minHeight: '60px', // Apply minimum height to the input area
                                        },
                                    }}
                                    onChange={handleLocalMessageChange}
                                    inputProps={{
                                        maxLength: 656,
                                    }}
                                />
                            </Box>
                            <Box style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                <Box>
                                    <Button
                                        onClick={handleSave}
                                        style={{
                                            width: '148px',
                                            height: '43px',
                                            backgroundColor: '#5379BD',
                                            color: 'white',
                                            borderRadius: '8px',
                                            textTransform: 'capitalize',
                                            fontSize: 'auto',
                                        }}
                                        sx={{ fontFamily: 'inherit' }}
                                        disabled={MessageLoading}
                                    >
                                        {' '}
                                        {MessageLoading ? 'Saving...' : 'Save'}
                                    </Button>
                                    {/* <LinearProgress sx={{ visibility: Loading ? '' : 'hidden' }} /> */}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
            </div>
        </>
    );
});

export default AddComplaintMessage;
